// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._4dktbNQk_GtOTpCyYHNQ{width:100%;background-color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchText": "_4dktbNQk_GtOTpCyYHNQ"
};
export default ___CSS_LOADER_EXPORT___;
